// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__NHTJY","unreadBadge":"styles_unreadBadge__32F4u","modalContent":"styles_modalContent__fkODO","modal":"styles_modal__3pv8x"};